import type { Action, Reducer, State } from '../use_candidate_profile';

export const notesReducer: Reducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'updateUnreadNotesCount': {
      return {
        ...state,
        unreadNotesCount: action.payload.count,
      };
    }
    default:
      return state;
  }
};
